// extracted by mini-css-extract-plugin
module.exports = {"hamburgerIconWrapper":"HamburgerIconSVG_hamburgerIconWrapper__3bgoK"};